import { getYear } from "date-fns";
import type { FC } from "react";
import { FlatRowDateDayView } from "web_myplann/Shared/Components/FlatRow/FlatRowDateDayView";
import { FlatRowDateMonthView } from "web_myplann/Shared/Components/FlatRow/FlatRowDateMonthView";
import { FlatRowDateYearView } from "web_myplann/Shared/Components/FlatRow/FlatRowDateYearView";
import { useDatePanelNavigation } from "web_myplann/Shared/Hooks/useDatePanelNavigation";
import {
	type DatePanelMode,
	DateView,
} from "web_myplann/Shared/Types/DateView";

type Props = {
	value: Date | null;
	mode: DatePanelMode;
	minDate?: Date;
	maxDate?: Date;
	onSelect: (date: Date) => void;
};

export const FlatRowDatePanel: FC<Props> = ({
	value,
	mode,
	minDate,
	maxDate,
	onSelect,
}) => {
	const {
		view,
		visibleMonth,
		visibleYear,
		highlightedMonth,
		setVisibleMonth,
		setVisibleYear,
		showMonths,
		showYears,
		selectYear,
		selectMonth,
		selectDay,
	} = useDatePanelNavigation({ value, mode, minDate, maxDate, onSelect });

	return (
		<>
			{view === DateView.Day && (
				<FlatRowDateDayView
					month={visibleMonth}
					value={value}
					minDate={minDate}
					maxDate={maxDate}
					onMonthChange={setVisibleMonth}
					onTitleClick={showMonths}
					onSelect={selectDay}
				/>
			)}
			{view === DateView.Month && (
				<FlatRowDateMonthView
					year={visibleYear}
					selectedMonth={highlightedMonth}
					minDate={minDate}
					maxDate={maxDate}
					onYearChange={setVisibleYear}
					onTitleClick={showYears}
					onSelect={selectMonth}
				/>
			)}
			{view === DateView.Year && (
				<FlatRowDateYearView
					year={visibleYear}
					selectedYear={highlightedMonth ? getYear(highlightedMonth) : null}
					minDate={minDate}
					maxDate={maxDate}
					onYearChange={setVisibleYear}
					onSelect={selectYear}
				/>
			)}
		</>
	);
};
